import { render, staticRenderFns } from "./InstagramAnimation.vue?vue&type=template&id=3e801087&"
import script from "./InstagramAnimation.vue?vue&type=script&lang=js&"
export * from "./InstagramAnimation.vue?vue&type=script&lang=js&"
import style0 from "./InstagramAnimation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports